import AcceptOfferDialog from './AcceptOfferDialog.vue'
import { ProgrammaticDialog } from '~/ui/elements'

export const AcceptOfferDialogProgrammatic = ProgrammaticDialog(AcceptOfferDialog)
export default AcceptOfferDialog
